export enum TableColumnKey {
  Operation = "operation",
  ChainName = "chain_name",
  Currency = "currency",
  WalletAddress = "wallet_address",
  ThresholdLower = "threshold_lower",
  ThresholdUpper = "threshold_upper",
  CreationTime = "creation_time",
  LastModifiedTime = "last_modified_time",
}
export type TableRow = {
  [TableColumnKey.Operation]: string;
  [TableColumnKey.ChainName]: string;
  [TableColumnKey.Currency]: string;
  [TableColumnKey.WalletAddress]: string;
  [TableColumnKey.ThresholdLower]: string;
  [TableColumnKey.ThresholdUpper]: string;
  [TableColumnKey.CreationTime]: string;
  [TableColumnKey.LastModifiedTime]: string;
};
